import { oapi, ApiError } from './officialsApi';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const bapi = oapi;
export { ApiError };

export const fmtMoney = (n, cur = 'USD') => `${cur} $${Number(n || 0).toFixed(2)}`;
// Marketing style used across the site: "$89 USD", "$16.58 USD".
export const priceUsd = (n) => `$${Number.isInteger(Number(n)) ? Number(n) : Number(n || 0).toFixed(2)} USD`;
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) : '—');
export const usd = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtDateTime = (d) => (d ? new Date(d).toLocaleString(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : '—');
export const brandLabel = (b) => ({ visa: 'Visa', mastercard: 'Mastercard' }[b] || 'Card');

// Hidden POST form to the hosted card page: card data never touches Schedule Guru.
export function submitHostedForm(url, fields) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;
  Object.entries(fields).forEach(([k, v]) => {
    const i = document.createElement('input');
    i.type = 'hidden';
    i.name = k;
    i.value = String(v);
    form.appendChild(i);
  });
  document.body.appendChild(form);
  form.submit();
}

export async function startHostedPayment(path, body = {}) {
  const r = await bapi(path, { method: 'POST', body });
  sessionStorage.setItem('sg-last-order', r.order_id);
  submitHostedForm(r.gateway_url, r.fields);
  return r;
}

export async function downloadReceipt(receiptId, number) {
  const token = localStorage.getItem('session_token');
  const res = await fetch(`${API_URL}/api/billing/receipts/${receiptId}/pdf`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!res.ok) throw new ApiError(res.status, 'Could not download the receipt');
  const url = URL.createObjectURL(await res.blob());
  const a = document.createElement('a');
  a.href = url;
  a.download = `schedule-guru-receipt-${number || receiptId}.pdf`;
  a.click();
  URL.revokeObjectURL(url);
}
